import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

// Image d'arrière-plan pour le footer
const FOOTER_BG_IMAGE = '/IMG4.jpg';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const quickLinks = [
    { path: '/', label: 'Accueil' },
    { path: '/services', label: 'Services' },
    { path: '/realisations', label: 'Réalisations' },
    { path: '/contact', label: 'Contact' }
  ];

  const services = [
    'Création de Sites Web',
    'Applications Mobiles',
    'E-commerce',
    'Design UI/UX'
  ];

  return (
    <footer>
      <div className="footer-bg" style={{ backgroundImage: `url(${FOOTER_BG_IMAGE})` }}></div>
      <div className="footer-top container">
        <div className="footer-col footer-brand-col">
          <Link to="/" onClick={scrollToTop} className="footer-brand-link">
            <img src="/cns.png" alt="Logo CNS" className="footer-logo" />
            <span className="footer-brand-name">
              <span className="brand-part-1">Cybernex</span>
              <span className="brand-part-2"> Services</span>
            </span>
          </Link>
          <p className="footer-brand-slogan">Transformer vos idées en expériences digitales performantes</p>
        </div>

        <div className="footer-col">
          <h4 className="footer-col-title">Liens Rapides</h4>
          <ul className="footer-col-list">
            {quickLinks.map((link) => (
              <li key={link.path}>
                <Link to={link.path} onClick={scrollToTop}>{link.label}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="footer-col">
          <h4 className="footer-col-title">Services</h4>
          <ul className="footer-col-list">
            {services.map((service, index) => (
              <li key={index}>{service}</li>
            ))}
          </ul>
        </div>

        <div className="footer-col footer-contact-col">
          <h4 className="footer-col-title">Contact</h4>
          <div className="footer-email">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
              <polyline points="22,6 12,13 2,6"></polyline>
            </svg>
            <a href="mailto:Cybernscontacts@gmail.com">Cybernscontacts@gmail.com</a>
          </div>
          <div className="footer-socials">
            <button type="button" aria-label="LinkedIn" className="social-icon" onClick={(e) => e.preventDefault()}>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
              </svg>
            </button>
            <button type="button" aria-label="Facebook" className="social-icon" onClick={(e) => e.preventDefault()}>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
              </svg>
            </button>
            <button type="button" aria-label="GitHub" className="social-icon" onClick={(e) => e.preventDefault()}>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
              </svg>
            </button>
          </div>
        </div>
      </div>

      <div className="footer-separator"></div>

      <div className="footer-bottom">
        <p className="footer-copyright">&copy; 2025 Cybernex Services. Tous droits réservés.</p>
        <p className="footer-bottom-slogan">Solutions digitales sur-mesure pour votre réussite.</p>
      </div>
    </footer>
  );
};

export default Footer;

